import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=c13852b2&"
import script from "./EntityHeader.vue?vue&type=script&lang=ts&"
export * from "./EntityHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports